import { sendRequest } from "./base";
import {
  GET_TOTAL_FEE_VS_PENDING,
  GET_TOTAL_TRANSACTIONS_CHARTS,
} from "../util/constants";

export const feeGraphInfo = async (data, token) => {
  const Authorization = `Bearer ${token}`;

  if (data.role === "manager") {

    let my_data = await JSON.parse(localStorage.getItem("persist:root"));
    my_data = await JSON.parse(my_data.user);
    try {
      data.school_id = await my_data.schoolId;
    } catch (error) {
      console.debug(error);
    }
  }
  else {
    data.school_id = 0;

  }
  try {
    return sendRequest(data, "POST", GET_TOTAL_FEE_VS_PENDING, {
      Authorization,
    });
  } catch (error) {
    return error;
  }
};

export const feeBarChartInfo = async (startDate, endDate, id, role, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(
      null,
      "GET",
      `${GET_TOTAL_TRANSACTIONS_CHARTS}?startDate=${startDate}&endDate=${endDate}&schoolId=${id}&userRole=${role}`,
      { Authorization }
    );
  } catch (error) {
    return error;
  }
};
